<template>
    <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    :value="displayDate"
                    :label="label"
                    prepend-icon="event"
                    readonly
                    v-on="on"
            ></v-text-field>
        </template>

        <v-date-picker v-model="date" @change="changed" @input="menu = false" locale="de-ch"></v-date-picker>
    </v-menu>
</template>

<script>
    import {getShortIsoDate} from "../helpers/dateHelper";

    export default {
        name: "DatePickerField",
        props: ["value", "label"],
        methods: {
            changed() {
                this.$emit("input", new Date(this.date))
            }
        },
        computed: {
            displayDate() {
                return new Date(this.date).toLocaleDateString("de-CH")
            }
        },
        data: () => ({
            menu: false,
            date: getShortIsoDate(new Date()),
        }),
      watch: {
          value (val) {
            this.date = getShortIsoDate(new Date(val))
          }
      },
        created() {
            this.date = getShortIsoDate(new Date(this.value));
        }
    }
</script>

<style scoped>

</style>